module.exports = __webpack_public_path__ + "static/media/great.461f4444.png";